// extracted by css-extract-rspack-plugin
var _1 = "priceBox__U0GxO";
var _2 = "priceBox__description__KqqE8";
var _3 = "priceBox__features__Sjok9";
var _4 = "priceBox__header__HQ13w";
var _5 = "priceBox__price__wmZjZ";
var _6 = "priceBox__quantifier__E4rrO";
export { _1 as "priceBox", _2 as "priceBox__description", _3 as "priceBox__features", _4 as "priceBox__header", _5 as "priceBox__price", _6 as "priceBox__quantifier" }
export default { "priceBox": _1, "priceBox__description": _2, "priceBox__features": _3, "priceBox__header": _4, "priceBox__price": _5, "priceBox__quantifier": _6 }
